/**
 * Switch, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/SwitchComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

import { generateId } from '../idGeneration';
import { toBuilderChild, toWhatsAppChild } from '../containerChildren';

export const SwitchCore = {
  type: 'Switch',
  name: 'Switch Block',
  icon: '🔀',
  description: 'Layout block that shows one branch of contents based on a value.',
  category: 'layout',
  maxPerScreen: null,
  getDefaultProperties() {
    return {
      _switchValue: '',
      cases: [
        { id: generateId(), caseValue: '', children: [] },
      ],
    };
  },
  validateProperties(properties) {
    const errors = [];
    if (!properties._switchValue?.trim()) {
      errors.push('Switch value is required');
    }
    const hasEmptyCaseValue = (properties.cases || []).some(c => !c.caseValue?.trim());
    if (hasEmptyCaseValue) {
      errors.push('All cases must have a value');
    }
    return { errors, warnings: [] };
  },
  transformToWhatsApp(properties) {
    const casesMap = {};
    for (const c of properties.cases || []) {
      if (c.caseValue != null && c.caseValue !== '') {
        casesMap[c.caseValue] = (c.children || []).map(toWhatsAppChild);
      }
    }
    return { type: 'Switch', value: properties._switchValue || '', cases: casesMap };
  },
  transformFromWhatsApp(wa) {
    const cases = Object.entries(wa.cases || {}).map(([caseValue, children]) => ({
      id: generateId(),
      caseValue,
      children: (children || []).map(toBuilderChild),
    }));
    return {
      _switchValue: wa.value || '',
      cases: cases.length > 0 ? cases : [{ id: generateId(), caseValue: '', children: [] }],
    };
  },
};
